<template>

        <before-after-slider :entries="getEntriesForSection" :section="section" />
        
        <!-- Before / After Modals -->
        <div v-for="patient in getEntriesForSection" :key="patient.image" id="beforeAfterModals">

          <before-after-modal :patient="patient" :section="section" />
          
        </div>
        <!-- Before / After Modals END -->

</template>

<script>
    const sections = require('../sliders.json')
    export default ({
        props: ['section'],
        setup() {
            return {
                sections,
            }
        },
        computed: {
            getEntriesForSection() {
                return sections.filter(section => section.type == this.section)[0]?.entries
            }
        }
    })
</script>